// extracted by mini-css-extract-plugin
module.exports = {"animation":"flash-bell-652fe81fbb5ffdc17e190954c6f3af80","wiggle":"flash-bell-bf669ac04004fbe15b69c5dde78b4647"};